import React from 'react';
import './FBXButtonVertical.style.scss';

const FBXButtonVertical = ({
    buttonID,
    expanded,
    expandedText,
    expandedColor,
    hasIcon,
    IconText,
    buttonIcon,
    isSelected,
    buttonColor,
    selectedColor,
    hoverColor,
    textColor,
    theTooltip,
    onClick,
    marginTop,
    badgeCount = 0,
    attention = false,
}) => {
    const cleanBadgeCount = Number.parseInt(badgeCount || 0, 10) || 0;

    const handleToggle = (event) => {
        if (onClick) {
          onClick(event, buttonID); // Pass event and buttonID to parent onClick handler
        }
    };

    return (
        expanded ? (
            <div
                title={theTooltip}
                onClick={handleToggle}
                className={`round-button-vert ${hasIcon === true ? 'icon' : 'isText'} ${attention ? 'fbx-vertical-attention' : ''}`}
                style={{
                    backgroundColor: attention ? undefined : (isSelected ? (selectedColor || 'orange') : buttonColor || 'transparent'), // Default to transparent if buttonColor is not set
                    '--fbx-vertical-hover-color': hoverColor || 'orange',
                    color: textColor || 'white',
                    marginBottom: "5px",
                    marginTop: marginTop || '0px',
                }}
            >
                {hasIcon ? (
                    <img src={buttonIcon} alt={IconText || 'Icon'} width="24" height="24" />
                ) : (
                    <span className='iconText'>{IconText}</span>
                )}
                {cleanBadgeCount > 0 && <span className="fbx-vertical-badge">{cleanBadgeCount}</span>}
            </div>
        ) : (
            <div
                title={theTooltip}
                onClick={handleToggle}
                className={`expand-container d-flex gap-3 p-2 text-white ${attention ? 'fbx-vertical-attention' : ''}`}
                style={{
                    backgroundColor: attention ? undefined : (isSelected ? (selectedColor || 'orange') : buttonColor || 'transparent'), // Default to transparent if buttonColor is not set
                    '--fbx-vertical-hover-color': hoverColor || 'orange',
                    color: textColor || 'white',
                    marginBottom: "10px",
                }}
            >
                {hasIcon ? (
                    <img className='iconText' src={buttonIcon} alt={IconText || 'Icon'} width="24" height="24" />
                ) : (
                    <span className='iconText'>{IconText}</span>
                )}
                <div
                 style={{
                    color: expandedColor || 'white',
                }}>{expandedText}</div>
                {cleanBadgeCount > 0 && <span className="fbx-vertical-badge fbx-vertical-badge-expanded">{cleanBadgeCount}</span>}
            </div>
        )
    );
};

export default FBXButtonVertical;
